// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-users-sync {
  padding: 8px 0 20px;
}

.skl-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.skl-config-row,
.skl-status-grid,
.skl-debug-grid {
  display: grid;
  gap: 20px;
}

.skl-config-row {
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
}

.skl-config-actions {
  display: flex;
  gap: 12px;
}

.skl-job-banner {
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  background: #f8f9fa;
}

.skl-status-grid {
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
}

.skl-status-action {
  display: flex;
  justify-content: flex-end;
}

.skl-progress {
  margin-top: 20px;
}

.skl-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.skl-stat-card {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  background: #fff;
  padding: 18px;
}

.skl-debug-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.skl-debug-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media (max-width: 991.98px) {
  .skl-stats-grid,
  .skl-debug-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .skl-config-row,
  .skl-status-grid {
    grid-template-columns: 1fr;
  }
  .skl-status-action,
  .skl-debug-action {
    justify-content: flex-start;
  }
}
@media (max-width: 575.98px) {
  .skl-stats-grid,
  .skl-debug-grid {
    grid-template-columns: 1fr;
  }
  .skl-config-actions {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/users-sync/users-sync-skeleton/users-sync-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;;EAGE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,0CAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE;;IAEE,gDAAA;EACF;EAEA;;IAEE,0BAAA;EAAF;EAGA;;IAEE,2BAAA;EADF;AACF;AAIA;EACE;;IAEE,0BAAA;EAFF;EAKA;IACE,eAAA;EAHF;AACF","sourcesContent":[".skl-users-sync {\n  padding: 8px 0 20px;\n}\n\n.skl-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.skl-config-row,\n.skl-status-grid,\n.skl-debug-grid {\n  display: grid;\n  gap: 20px;\n}\n\n.skl-config-row {\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: end;\n}\n\n.skl-config-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.skl-job-banner {\n  padding: 16px;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  background: #f8f9fa;\n}\n\n.skl-status-grid {\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n}\n\n.skl-status-action {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.skl-progress {\n  margin-top: 20px;\n}\n\n.skl-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.skl-stat-card {\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  background: #fff;\n  padding: 18px;\n}\n\n.skl-debug-grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.skl-debug-action {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-stats-grid,\n  .skl-debug-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .skl-config-row,\n  .skl-status-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .skl-status-action,\n  .skl-debug-action {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .skl-stats-grid,\n  .skl-debug-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .skl-config-actions {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
